import * as React from "react";
import { Grid } from "@material-ui/core";
import { useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { useLocale, useSetLocale } from "react-admin";
import { DOMAIN_K, DOMAIN_R, domainTheme } from "../themes/theme";

export const LocaleSwitcher = () => {
  const useStyles = makeStyles(() => ({
    leftTxtPos: {
      justifyContent: "flex-end",
      cursor: "pointer",
    },
    rightTxtPos: {
      justifyContent: "flex-end",
      cursor: "pointer",
    },
    activeK: {
      color: "#d95a27 !important",
    },
    active: {
      fontWeight: "800",
    },
    separator: {
      margin: "0 5px",
    },
    button: {
      background: "transparent",
      border: "none",
      color: "white",
      padding: 0,
      margin: 0,
    },
  }));

  var domain = window.location.toString();

  const locale = useLocale();
  const setLocale = useSetLocale();
  const translate = useTranslate();
  const classes = useStyles();

  return (
    <>
      {domainTheme !== DOMAIN_K && domainTheme !== DOMAIN_R && <Grid></Grid>}
      {domainTheme === DOMAIN_K && (
        <Grid>
          <button
            className={`${classes.button}
               ${classes.leftTxtPos}
               ${locale !== "es" ? "" : classes.active}
               ${
                 locale !== "es"
                   ? ""
                   : domain.includes("login")
                   ? classes.activeK
                   : ""
               }
             `}
            onClick={() => setLocale("es")}
          >
            {translate("ra.location.es.k")}
          </button>
          <span className={classes.separator}>|</span>
          <button
            className={`${classes.button}
                ${classes.rightTxtPos}
                ${locale !== "eu" ? "" : classes.active}
                ${
                  locale !== "eu"
                    ? ""
                    : domain.includes("login")
                    ? classes.activeK
                    : ""
                }
              `}
            onClick={() => setLocale("eu")}
          >
            {translate("ra.location.eu")}
          </button>
        </Grid>
      )}
      {domainTheme === DOMAIN_R && (
        <Grid>
          <button
            className={`${classes.button} ${classes.leftTxtPos} ${
              locale !== "es" ? "" : classes.active
            }`}
            onClick={() => setLocale("es")}
          >
            {translate("ra.location.es.r")}
          </button>
          <span className={classes.separator}>|</span>
          <button
            className={`${classes.button} ${classes.rightTxtPos} ${
              locale !== "gl" ? "" : classes.active
            }`}
            onClick={() => setLocale("gl")}
          >
            {translate("ra.location.gl")}
          </button>
        </Grid>
      )}
    </>
  );
};
